import { CollapsibleTable, WorkshopTableWrapper } from 'pages/Workshop/common';
import { Spinner } from 'components';

export const WorkshopTabsTable = (props) => {
  const { dataSource, loading, ...tableProps } = props;

  const { emptyText, ...restTableProps } = tableProps;

  if (loading) return <Spinner />;

  return (
    <WorkshopTableWrapper data={[...dataSource]} emptyText={emptyText}>
      <CollapsibleTable title={''} {...restTableProps} dataSource={dataSource} disableCollapse />
    </WorkshopTableWrapper>
  );
};
